import { AnimatedText } from "../components/shared/AnimatedText";
import { MobileCourseList } from "../components/Courses/CourseCard";
import { COURSE_CARDS_I18N } from "../data/courses";

export function CoursesSection({ t, lang }) {
  return (
    <section id="courses" className="bg-gray-50 py-12 md:py-20">
      <div className="container mx-auto px-3 md:px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8 md:mb-14">
            <AnimatedText text={t.courses.title} tag="h2" className="text-3xl md:text-5xl font-black text-blue-900 mb-4" />
            <AnimatedText text={t.courses.subtitle} tag="p" delay={80} className="text-gray-700 text-base md:text-lg max-w-3xl mx-auto" />
          </div>
          <MobileCourseList
            cards={COURSE_CARDS_I18N[lang] || COURSE_CARDS_I18N.en}
            enrollBtn={t.courses.enrollBtn}
            lang={lang}
            overviewLabel={t.courses.overviewLabel}
            learnLabel={t.courses.learnLabel}
            outcomeLabel={t.courses.outcomeLabel}
          />
        </div>
      </div>
    </section>
  );
}
